import EventManager from './event-manager';
import { useCallback } from 'react';
import { getGameClientFrame } from '@/utilities/getters/getGameClientFrame';
import { getIframeTargetOrigin } from '@/utilities/getters/getIframeTargetOrigin';
import { useStore } from '@/store/useStore';

const useEventManagerEmitter = () => {
  const clientLoaded = useStore((s) => s.clientStatus.loaded);

  const emitClientEvent = useCallback(
    (type: string, payload?: unknown) => {
      const frame = getGameClientFrame();
      if (!clientLoaded || !frame?.contentWindow) {
        console.warn(
          '[EVENT MANAGER] Cannot emit event, client not loaded or iframe not available',
        );
        return;
      }
      EventManager.emit(
        frame.contentWindow,
        'message',
        type,
        payload,
        getIframeTargetOrigin(frame.src),
      );
    },
    [clientLoaded],
  );

  return { emitClientEvent };
};

export default useEventManagerEmitter;
